import { Layout } from 'antd';
import React, { ReactNode } from 'react';
import { Resizable, ResizeCallbackData } from 'react-resizable';
const { Sider } = Layout;

const CLASSNAME = "resizable-sider";

export interface ResizableSiderProps {
    children: ReactNode[] | ReactNode;
    style?: React.CSSProperties,
    handleStyle?: React.CSSProperties,
    className?: string,
    defaultWidth: number;
    collapsedWidth?: number;
    minWidth?: number;
    maxWidth?: number;
    collapsed: boolean;
    placement?: 'east' | 'west';
    callback?: (width: number) => void;
    callbackStart?: (width: number) => void;
    callbackStop?: (width: number) => void;
    disableResizing?: boolean,
    enableTransitions?: boolean
}

export const ResizableSider: React.FC<ResizableSiderProps> = ({
    children,
    style,
    handleStyle,
    className = "",
    defaultWidth,
    collapsedWidth = 0,
    minWidth = 270,
    maxWidth = Number.MAX_SAFE_INTEGER,
    collapsed,
    placement,
    callback,
    callbackStart,
    callbackStop,
    disableResizing,
    enableTransitions
}) => {

    // states
    const [width, setWidth] = React.useState(defaultWidth);
    const [resizing, setResizing] = React.useState(false);

    React.useEffect(() => {
        if (width > maxWidth) {
            setWidth(maxWidth);
        }
    }, [maxWidth]);

    // handlers
    const handleInfoSiderResize = (e: React.SyntheticEvent<Element, Event>, data: ResizeCallbackData) => {
        if (!disableResizing) {
            setWidth(data.size.width);
            if (callback)
                callback(data.size.width);
        }
    }

    const handleResizeStart = (e: React.SyntheticEvent, data: ResizeCallbackData) => {
        if (callbackStart)
            callbackStart(data.size.width);

        setResizing(true);
    }

    const handleResizeStop = (e: React.SyntheticEvent, data: ResizeCallbackData) => {
        if (callbackStop)
            callbackStop(data.size.width);

        setResizing(false);
    }

    const handleStyleInner: React.CSSProperties = {
        position: 'absolute',
        zIndex: 500,
        width: '6px',
        height: '100%',
        background: 'transparent',
        bottom: 0,
        cursor: 'col-resize',
        display: disableResizing || collapsed ? 'none' : '',
        ...handleStyle
    }

    if (placement === 'east') {
        handleStyleInner.left = '-3px';

    } else {
        handleStyleInner.right = '-3px';
    }

    return (
        <Resizable
            width={width}
            height={100}
            minConstraints={[minWidth, 0]}
            maxConstraints={[maxWidth, Number.MAX_SAFE_INTEGER]}
            handle={<span className={`${CLASSNAME}-handle`} style={handleStyleInner}></span>}
            resizeHandles={placement === 'east' ? ['w'] : ['e']}
            onResize={handleInfoSiderResize}
            onResizeStart={handleResizeStart}
            onResizeStop={handleResizeStop}
        >
            <Sider
                width={width}
                style={{ ...style, transition: (!enableTransitions || resizing) ? 'none' : 'all 0.2s' }}
                className={`${CLASSNAME} ${className}`}
                collapsed={collapsed}
                collapsedWidth={collapsedWidth}>
                {children}
            </Sider>
        </Resizable>
    );
}

export default ResizableSider;